<div class="container" id="wrap">
    <div class="col-lg-12">
        <br />
    </div>
    <div class="col-lg-12">
        <div class="col-lg-3"></div>
        <div class="col-lg-6 text-center">
            <img class="logo-landing" src="assets/images/logos/ic.svg" style="width: 70%;" alt="" />
        </div>
        <div class="col-lg-3"></div>
    </div>
    <div class="col-lg-12">
        <br />
    </div>
    <div class="col-lg-12">
        <div class="col-lg-3"></div>
        <div class="col-lg-6">
            <div class="alert alert-danger" role="alert">
                Estamos cerrando su sesión, favor espere un momento.
            </div>
        </div>
        <div class="col-lg-3"></div>
    </div>
    <!-- <div *ngIf="productos">
        <iframe style="display:none;" [src]="getUrl(prod)" *ngFor="let prod of productos">
        </iframe>
    </div> -->
</div>